import * as React from 'react';
import $ from 'jquery';
import { Trad, BaseComponent } from '../../components/';

export class PortletToogleIcon extends BaseComponent {
public constructor(props: any) {
        super(props);
    }

    private initializeTooltip() {
        $(".kt-portlet .tooltip-portlet .tooltip-inner").text(Trad.Trad("Collapse"));
        $(".kt-portlet--collapse .tooltip-portlet .tooltip-inner").text(Trad.Trad("Expand"));
    }

    public render() {
        return (
            <a
                href="#"
                className="btn btn-sm btn-icon btn-clean btn-icon-md"
                data-ktportlet-tool="toggle"
                onMouseOver={this.initializeTooltip}
                onClick={this.initializeTooltip}
            >
                <i className="la la-angle-down" />
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/PortletToogleIcon.tsx